import { render, staticRenderFns } from "./SourceOfFunds.vue?vue&type=template&id=3a448014&scoped=true&"
import script from "./SourceOfFunds.vue?vue&type=script&lang=js&"
export * from "./SourceOfFunds.vue?vue&type=script&lang=js&"
import style0 from "./SourceOfFunds.vue?vue&type=style&index=0&id=3a448014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a448014",
  null
  
)

export default component.exports